import { useState, useEffect } from 'react';
import { SellerStoreInfoPage } from './auth/SellerStoreInfoPage';
import { DesktopSellerStoreInfoPage } from './desktop/DesktopSellerStoreInfoPage';

export function ResponsiveSellerStoreInfoPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SellerStoreInfoPage /> : <DesktopSellerStoreInfoPage />;
}